import React from "react";

type PropsType = {
  title?: string;
  children?: any; 
  btnTitle?: string;
};

const DashboardHeroSection = ({ title, btnTitle, children }: PropsType) => {
  return (
    <section id="hero">
      <div className="tw-w-full tw-bg-[#F7F7F7]">
        {/* first Item */}
        <div className="tw-flex tw-py-6 tw-pl-4 lg:tw-pl-14 tw-bg-[#F7F7F7] tw-items-center tw-justify-between tw-border-8">
          <p className="tw-text-[30px] lg:tw-text-[35px] tw-text-black tw-font-bold">
            {title}
          </p>
        </div>

        {/* second Item */}
        <div className="tw-w-full tw-flex tw-flex-col tw-pt-12 tw-pb-36 tw-rounded-t-3xl tw-shadow-inner  tw-relative">
          <div
            className="tw-h-full tw-absolute tw-inset-0 tw-bg-[url('/src/assets/images/section-bg.svg')] tw-rounded-t-3xl tw-bg-left lg:tw-bg-center tw-bg-no-repeat tw-bg-auto lg:tw-bg-cover"
            style={{ mixBlendMode: "luminosity" }}
          ></div>
          {/* Rest of your content */}
          <div className="tw-z-10 tw-flex tw-flex-col tw-gap-8">{children}</div>
        </div>
      </div>
    </section>
  );
};

export default DashboardHeroSection;